module.exports = __webpack_public_path__ + "img/preco_dependente2.46ef65b2.png";